import './Footer.scss';

const Footer = () => {
  return <footer className='footer'>&#169; 2024 #VANLIFE</footer>;
};

export default Footer;
